import { render } from "./company-document-page.vue?vue&type=template&id=30d073f6&scoped=true"
import script from "./company-document-page.vue?vue&type=script&lang=js"
export * from "./company-document-page.vue?vue&type=script&lang=js"

import "./company-document-page.vue?vue&type=style&index=0&id=30d073f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d073f6"]])

export default __exports__